import { useEffect, useState } from "react";
import {
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useDisclosure,
    Text,
    Switch,
    Flex
} from "@chakra-ui/react";
import { InfoIconOutlineYellow } from "../../../styles/icons/InfoIconOutlineYellow";
import { useParams } from "react-router-dom";
import { showToast } from "../../../utils/toast";
import { useSeller } from "../../../hooks/useSeller";
import { useFeatureToggles } from "../../../hooks/useFeatureToggles";
export function ModalActiveBanking({ activeBanking }) {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [modalType, setModalType] = useState<"activate" | "deactivate" | null>(null);
    const { id } = useParams();
    const { patchActiveBanking } = useSeller();
    const [updatedActiveBanking, setUpdatedActiveBanking] = useState(activeBanking);
    const [isFeatureLoading, setIsFeatureLoading] = useState(false);
    const [initialData, setInitialData] = useState<number[]>([]);
    const { loadInitialData, postFeatureToggles } = useFeatureToggles();
    async function getInitialData() {
        try {
            setIsFeatureLoading(true);
            const response = await loadInitialData();
            const betaSellers = response.data
                .filter((item: any) => item.name === "view_banking_account")
                .flatMap((item: any) => item.betaSellers);
            setInitialData(betaSellers);
        } catch (error) {
            error?.response?.data?.errors?.map((error:any) => (
                showToast({
                    type: "error",
                    message: `${error?.code} - ${error?.description}`
                })
            ));
        } finally {
            setIsFeatureLoading(false);
        }
    }
    async function handleAddSellerToggle() {
        try {
            const updatedBetaSellers = [...initialData];
            updatedBetaSellers.push(Number(id));
            await postFeatureToggles({
                toggleName: "view_banking_account",
                sellerIds: updatedBetaSellers
            });
            setInitialData(updatedBetaSellers);
            await patchActiveBanking(id, true);

            showToast({
                type: "success",
                message: "Banking ativado com sucesso"
            });
            setUpdatedActiveBanking(true);
        } catch (error) {
            console.error(error);
        } finally {
            handleCloseModal();
        }
    }
    async function handleRemoveSellerToggle() {
        try {
            const updatedBetaSellers = [...initialData];
            updatedBetaSellers.splice(updatedBetaSellers.indexOf(Number(id)), 1);
            await postFeatureToggles({
                toggleName: "view_banking_account",
                sellerIds: updatedBetaSellers
            });
            setInitialData(updatedBetaSellers);
            await patchActiveBanking(id, false);
            showToast({
                type: "success",
                message: "Banking desativado com sucesso"
            });
            setUpdatedActiveBanking(false);
        } catch (error) {
            console.error(error);
        } finally {
            handleCloseModal();
        }
    }

    const handleToggle = (e) => {
        const isChecked = e.target.checked;
        if (isChecked) {
            setModalType("activate");
        } else if (!isChecked) {
            setModalType("deactivate");
        } else {
            setModalType(null);
        }
        onOpen();
    };

    const handleCloseModal = () => {
        setModalType(null);
        onClose();
    };
    useEffect(() => {
        getInitialData();
        //eslint-disable-next-line
    }, []);
    return (
        <>
            <Switch
                id="creditCard"
                isChecked={updatedActiveBanking}
                size="sm"
                sx={{
                    "& .chakra-switch__track": { backgroundColor: "gray.300" },
                    "& .chakra-switch__track[data-checked]": { backgroundColor: "red.500" },
                    "& .chakra-switch__thumb": { backgroundColor: "white" }
                }}
                onChange={handleToggle}
            />

            <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={handleCloseModal}>
                <ModalOverlay />
                {modalType === "deactivate" && (
                    <ModalContent p="0" gap="8px" borderRadius="2px" alignSelf="center">
                        <Flex p="32px 32px 24px 32px" gap="16px">
                            <Flex>
                                <InfoIconOutlineYellow size={24} />
                            </Flex>
                            <Flex flexDirection="column" gap="8px">
                                <ModalHeader
                                    p="0"
                                    fontSize="16px"
                                    color="rgba(0, 0, 0, 0.85)"

                                >
                                    Desativar banking?
                                </ModalHeader>
                                <ModalBody
                                    p="5px 0"
                                    fontSize="14px"
                                    fontWeight="400"
                                    color="rgba(0, 0, 0, 0.85)">
                                    <Text>
                                        Ao confirmar, o banking será desativado para o seller. peça para o mesmo relogar no sistema.
                                    </Text>
                                </ModalBody>
                                <ModalFooter p="0">
                                    <Flex gap="8px">
                                        <Button
                                            fontSize="14px"
                                            fontWeight="400"
                                            h="32px"
                                            onClick={handleCloseModal}
                                            variant="outline"
                                            w="89px"
                                            borderRadius="2px"
                                            color="black"
                                        >
                                            Cancelar
                                        </Button>
                                        <Button
                                            fontSize="14px"
                                            fontWeight="400"
                                            backgroundColor="var(--Yellow-400, rgba(198, 138, 49, 1))"
                                            color="white"
                                            w="93px"
                                            h="32px"
                                            onClick={handleRemoveSellerToggle}
                                            borderRadius="2px"

                                        >
                                            Desativar
                                        </Button>
                                    </Flex>
                                </ModalFooter>
                            </Flex>
                        </Flex>
                    </ModalContent>
                )}

                {modalType === "activate" && (
                    <ModalContent p="0" gap="8px" borderRadius="2px" alignSelf="center">
                        <Flex p="32px 32px 24px 32px" w="400" gap="16px" lineHeight="22px">
                            <Flex>
                                <InfoIconOutlineYellow size={24} />
                            </Flex>
                            <Flex flexDirection="column" gap="8px">
                                <ModalHeader p="0" fontSize="16px" fontWeight="600" color="rgba(0, 0, 0, 0.85)">
                                    Ativar banking
                                </ModalHeader>
                                <ModalBody p="5px 0 " fontSize="14px" fontWeight="400" color="rgba(0, 0, 0, 0.85)">
                                    <Text>
                                        Ao confirmar, o banking será ativado para o seller. peça para o mesmo relogar no sistema.
                                    </Text>
                                </ModalBody>
                                <ModalFooter p="0">
                                    <Flex gap="8px">
                                        <Button
                                            fontSize="14px"
                                            fontWeight="400"
                                            h="32px"
                                            onClick={handleCloseModal}
                                            variant="outline"
                                            w="89px"
                                            borderRadius="2px"
                                            color="black"
                                        >
                                            Cancelar
                                        </Button>
                                        <Button
                                            fontSize="14px"
                                            fontWeight="400"
                                            backgroundColor="var(--Yellow-400, rgba(198, 138, 49, 1))"
                                            color="white"
                                            w="93px"
                                            h="32px"
                                            onClick={handleAddSellerToggle}
                                            borderRadius="2px"
                                            isLoading={isFeatureLoading}
                                        >
                                            Ativar
                                        </Button>
                                    </Flex>
                                </ModalFooter>
                            </Flex>
                        </Flex>
                    </ModalContent>
                )}
            </Modal>
        </>
    );
}
